import {
  AfterContentInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output
} from '@angular/core';

import { ModalSwipeDirective } from './modal-swipe.directive';

@Directive({
  selector: '[appBottomSwipeSheet]',
  standalone: true
})
export class BottomSwipeSheetDirective implements AfterContentInit {
  constructor(
    private bottomSwipeSheet: ElementRef,
    private modalSwipe: ModalSwipeDirective
  ) { }

  private touchStartPoint: number;
  private currentPoint: number;
  private modalWidth: number;
  private modalHeight: number;
  private isTrueDirection: boolean = true;
  private overlayOpacity: number;
  private axis: 'X' | 'Y';
  private isUpOrLeft: 1 | -1;
  private modalBodyScrollTop: number;
  private modalBodyScrollLeft: number;

  @HostBinding('style.transform') transform: string;
  @HostBinding('style.transition') transition: string;

  @Input() direction: 'up' | 'down' | 'left' | 'right' = 'down';

  @Output()
  swipeAnimationEnd: EventEmitter<any> = new EventEmitter();

  ngAfterContentInit(): void {
    this.axis = this.getAxis(this.direction);
    this.isUpOrLeft = ['up', 'left'].includes(this.direction) ? -1 : 1;
    this.currentPoint = 0;
    this.modalBodyScrollTop = 0;
    this.modalBodyScrollLeft = 0;

    setTimeout(() => {
      this.modalWidth = this.bottomSwipeSheet.nativeElement.offsetWidth;
      this.modalHeight = this.bottomSwipeSheet.nativeElement.offsetHeight;
    }, 300);
  }

  @HostListener('touchstart', ['$event']) touchStart(event: TouchEvent): void {
    this.touchStartPoint = event.touches[0][`client${this.axis}`];
    this.modalBodyScrollTop = this.bottomSwipeSheet.nativeElement.querySelector('.modal__body.l-wrapper')?.scrollTop ?? 0;
    this.modalBodyScrollLeft = this.bottomSwipeSheet.nativeElement.querySelector('.modal__body.l-wrapper')?.scrollLeft ?? 0;
  }

  @HostListener('touchmove', ['$event']) touchMove(event: TouchEvent): void {
    const modalPoint = event.touches[0][`client${this.axis}`];
    const diff = modalPoint - this.touchStartPoint;
    this.isTrueDirection = this.isUpOrLeft * diff > 0;

    this.currentPoint = diff - (this.axis === 'Y' ? this.modalBodyScrollTop : this.modalBodyScrollLeft);

    if (this.isTrueDirection && this.isUpOrLeft * this.currentPoint > 0) {
      this.transform = `translate${this.axis}(${this.currentPoint}px)`;
      this.transition = 'none 0s ease 0s';

      this.overlayOpacity = (100 - (this.currentPoint * 100 / this.modalHeight)) / 100;
      this.modalSwipe.overlaySwipe.setOpacity(this.overlayOpacity);
    }
  }

  @HostListener('touchend', ['$event']) touchEnd(): void {
    if (this.isTrueDirection && this.isUpOrLeft * this.currentPoint > 0) {
      this.swipeModal();
    }

    this.currentPoint = 0;
    this.modalBodyScrollTop = 0;
    this.modalBodyScrollLeft = 0;
  }

  swipeModal(direction?: 'up' | 'down' | 'left' | 'right'): void {
    this.transition = '.3s ease transform';

    direction = direction || this.direction;
    const axis = this.getAxis(direction);

    switch (direction) {
      case 'up':
        this.transform = `translate${axis}(-${this.modalHeight}px)`;
        break;
      case 'down':
        this.transform = `translate${axis}(${this.modalHeight}px)`;
        break;
      case 'left':
        this.transform = `translate${axis}(-${this.modalWidth}px)`;
        break;
      case 'right':
        this.transform = `translate${axis}(${this.modalWidth}px)`;
        break;
    }

    setTimeout(() => {
      this.swipeAnimationEnd.emit();
    }, 150);
  }

  private getAxis(direction: 'up' | 'down' | 'left' | 'right') {
    return ['up', 'down'].includes(direction) ? 'Y' : 'X';
  }
}
